import Cookies from "universal-cookie";

const { fetch: originalFetch } = window;

export function initInterceptor() {
    window.fetch = async (...args) => {
        let [resource, config] = args;
        let cookies = new Cookies();
        let user = cookies.get('user');
        if (user) {
            if (user && user.token) {
                if (config == null) {
                    config = {};
                }
                if (!config.headers) {
                    config.headers = {};
                }
                config.headers.Authorization = 'Bearer ' + user.token;
            }
        }

        const response = await originalFetch(resource, config);
        if (response.status === 401) {
            window.location.href = '/login';
        }
        return response;
    };
}